<div class="payment-callback-container">
  <!-- Loading State -->
  @if (isProcessing()) {
    <div class="loading-spinner">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <p class="loading-text">Processing your payment...</p>
      <p class="sub-text">Please wait while we verify your transaction</p>
    </div>
  }
  
  <!-- Success State -->
  @if (isSuccess() && !isProcessing()) {
    <div class="success-message">
      <div class="success-icon">✓</div>
      <h2>Payment Successful!</h2>
      @if (isCheckout()) {
        <p>Your order has been confirmed successfully!</p>
      } @else {
        <p>Your shopping card has been funded successfully.</p>
      }
      @if (transactionRef()) {
        <p class="transaction-ref">Transaction Reference: {{ transactionRef() }}</p>
      }
      <button type="button" pButton label="Continue Shopping" (click)="continueShopping()" class="p-button-primary continue-btn"></button>
    </div>
  }
  
  <!-- Error State -->
  @if (isError() && !isProcessing()) {
    <div class="error-message">
      <div class="error-icon">✗</div>
      <h2>Payment Failed</h2>
      <p class="error-description">{{ getFormattedErrorMessage() }}</p>
      @if (transactionRef()) {
        <p class="transaction-ref">Transaction Reference: {{ transactionRef() }}</p>
      }
      <button type="button" pButton label="Continue Shopping" (click)="continueShopping()" class="p-button-primary continue-btn"></button>
    </div>
  }
</div>

<p-toast position="bottom-right"></p-toast>
